export default __webpack_public_path__ + "static/media/modal-close-button.60045f2a.svg";